import React from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { Modal } from 'antd'
import '../../css/zoom.scss'

const Zoom = ({ imageUrl, onClose, imageopen }) => {
  return (
    <Modal
      visible={imageopen}
      onCancel={onClose}
      footer={null}
      centered={false}
      width='50vw'
      bodyStyle={{
        padding: 0,
        height: '70vh',
        minHeight: '600px',
      }}
      className='zoom-modal'
      destroyOnClose
    >
      <TransformWrapper
        initialScale={0.8}
        minScale={0.3}
        maxScale={8}
        centerOnInit
      >
        <TransformComponent
          wrapperStyle={{
            width: '100%',
            height: '100%',
          }}
        >
          <img
            src={imageUrl}
            alt='Zoomable'
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </TransformComponent>
      </TransformWrapper>
    </Modal>
  )
}

export default Zoom
